/**
 * userChosenMunicipio
 * --------------------------------------------------------------
 * Persistent storage for the público-side user's chosen município.
 * Source of truth for tenant resolution PRIORITY:
 *   1. URL slug (e.g. /ponte-nova/explorar)               — explicit
 *   2. User-chosen via CitySelector / "Selecionar cidade" — explicit
 *   3. Cached geo lookup (sessionStorage, 30 min TTL)      — derived
 *   4. Fresh geo lookup (LocationContext)                  — derived
 *
 * The user's choice (#2) NEVER gets overwritten by geolocation. We persist
 * it in localStorage so it survives reloads, new tabs, and works across all
 * public pages (Home, Explorar, Vagas, Noticias, Promocoes).
 */
const KEY = 'user_chosen_municipio';

export function getUserChosenMunicipio() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw || raw === 'null' || raw === 'undefined') return null;
    const parsed = JSON.parse(raw);
    // Validate shape — discard stale/incompatible entries.
    if (!parsed || typeof parsed !== 'object' || !parsed.slug) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setUserChosenMunicipio(municipio) {
  try {
    if (!municipio) {
      localStorage.removeItem(KEY);
      return;
    }
    localStorage.setItem(KEY, JSON.stringify(municipio));
    // Notify listeners so pages can react without reload.
    window.dispatchEvent(new CustomEvent('userMunicipio:changed', { detail: municipio }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearUserChosenMunicipio() {
  setUserChosenMunicipio(null);
  window.dispatchEvent(new CustomEvent('userMunicipio:changed', { detail: null }));
}

export const USER_CHOSEN_MUNICIPIO_EVENT = 'userMunicipio:changed';
